jQuery(document).ready(function ($) {
    const $items = $('.main-navigation > ul > .menu-item-has-children');
    const $triggers = $items.children('a');
    const $header = $('.site-header');
    const $searchButton = $('.search-button');
    const $searchForm = $('.search__form');

    $(window)
        .on('scroll', function () {
            $header.toggleClass('scrolled', $(this).scrollTop() > 0);
        })
        .trigger('scroll');

    function closeMegaMenu() {
        $items
            .removeClass('active')
            .children('.mega-menu')
            .removeClass('active');
    }

    function closeSearch() {
        $searchForm.removeClass('active');
    }

    function closeHeader() {
        closeMegaMenu();
        closeSearch();
        $header.removeClass('active');
    }

    $triggers.on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        const $current = $(this).parent();
        const isActive = $current.hasClass('active');

        closeHeader();

        if (!isActive) {
            $current
                .addClass('active')
                .children('.mega-menu')
                .addClass('active');

            $header.addClass('active');
        }
    });

    $searchButton.on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        const isSearchActive = $searchForm.hasClass('active');

        closeMegaMenu();
        closeSearch();

        $('#navigation').removeClass('active');
        if (isSearchActive) {
            $header.removeClass('active');
            return;
        }
        $('body').removeClass('blocked');
        $header.addClass('active');
        $searchForm.addClass('active');
    });

    $('.site-search__close').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        closeHeader();
    });

    $('.main-navigation .mega-menu, .site-search').on(
        'click',
        function (event) {
            event.stopPropagation();
        }
    );

    $(document).on('click', function () {
        closeHeader();
    });

    $('.site-footer__columns .title').on('click', function () {
        if ($(window).width() > 660) {
            return;
        }

        $(this)
            .next('.wrapper')
            .slideToggle(300);
        $(this).toggleClass('active');
    });

    $('.burger-mobile-menu').on('click', function () {
        $('#navigation').addClass('active');
        $('body').addClass('blocked');
    });

    $('.close-nav').on('click', function () {
        $('#navigation').removeClass('active');
        $('body').removeClass('blocked');
    });

    $('.mega-menu__back').on('click', function () {
        $('.menu-item-has-children').removeClass('active');
        $(this).closest('.mega-menu').removeClass('active');
    });
});